import { FormattedMessage } from "react-intl";
import ChartExportActions from "component/shared/ChartExportActions/ChartExportActions";
import TableExportActions from "component/shared/TableExportActions/TableExportActions";

function ExportSection({
  dir,
  show,
  colHeaders,
  allChartData,
  yearType,
  currentLocale,
  tableExportFilename,
  tableExportTitle,
  excelImage,
  hasExportableData,
  onExportPdf,
  onExportPng,
  onExportJpeg,
}) {
  return (
    <div className="row gx-md-4 gx-0 gy-md-0 gy-3 my-3">
      <div className="col-md-4">
        <div className="item-show-data">
          <div className="title">
            <h5>
              <FormattedMessage id="download-chart-table" />:
            </h5>
          </div>
          <div className="content">
            {!show ? (
              <TableExportActions
                className={dir === "rtl" ? "ms-1" : "me-1"}
                columns={colHeaders}
                rows={allChartData}
                yearType={yearType}
                currentLocale={currentLocale}
                filename={tableExportFilename}
                tableId="table-to-xls"
                excelImage={excelImage}
                metadata={{
                  title: tableExportTitle,
                  locale: currentLocale,
                }}
              />
            ) : null}
            {show ? (
              <ChartExportActions
                className={dir === "rtl" ? "ms-1" : "me-1"}
                hasData={hasExportableData}
                onExportPdf={onExportPdf}
                onExportPng={onExportPng}
                onExportJpeg={onExportJpeg}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExportSection;
